import { z } from 'zod';
import type { IpgGatewayTransactionDetails } from '../../types/ipg/ipg-gateway-transaction-details-registry';
import { CardPointeNormalizedGatewayTransactionDetailsSchema } from './cardpointe/cardpointe-transaction-details.schemas';
import { CloverNormalizedGatewayTransactionDetailsSchema } from './clover/clover-transaction-details.schemas';
import { ValorGatewayTransactionDetailsSchema } from './valor/valor-payment.schemas';

export const IpgGatewayTransactionDetailsSchema: z.ZodType<IpgGatewayTransactionDetails> = z.union([
    ValorGatewayTransactionDetailsSchema,
    CardPointeNormalizedGatewayTransactionDetailsSchema,
    CloverNormalizedGatewayTransactionDetailsSchema,
]);
